import type { ReportId, ReportType, ReportMetadata } from '@reports/domain/types';
import type { ReportFilterConfig, ReportSection, ExportConfig } from '@reports/domain/value-objects';

/**
 * Main entity for all reports
 *
 * Encapsulates report logic with validation and business rules.
 * Immutable by design to ensure data integrity.
 *
 * @example
 * const report: Report = {
 *   id: 'sales-report',
 *   type: ReportType.SALES,
 *   metadata: metadataReport,
 *   filters: filters,
 *   sections: sections,
 *   export: exportConfig,
 * };
 */
export type Report = Readonly<{
  id: ReportId;
  type: ReportType;
  metadata: ReportMetadata;
  filters: ReportFilterConfig[];
  sections: ReportSection[];
  export: ExportConfig;
}>;

/** Factory function to create a ReportId */
export const createReportId = (id: string): ReportId => {
  if (!id?.trim()) {
    throw new Error('Report ID is required');
  }

  return id as ReportId;
};
